import { CreditCard } from './CreditCard';

export { CreditCard };

export default CreditCard;
